import { AsyncModule } from "vuex-async-mutations";

import meter from "./meter";

import regularInstallation from "./installationTypes/regular";
import monitoringonlyInstallation from "./installationTypes/monitoringonly";
import powershareInstallation from "./installationTypes/powershare";
import pvtInstallation from "./installationTypes/pvt";
import allinInstallation from "./installationTypes/allin";
import postalcoderoseInstallation from "./installationTypes/postalcoderose";
import retrofitInstallation from "./installationTypes/retrofit";
import hybridInstallation from "./installationTypes/hybrid";
import withoutprojects from "./installationTypes/withoutprojects";

export default {
    namespaced: true,

    async: true,

    modules: {
        regularInstallation,
        monitoringonlyInstallation,
        powershareInstallation,
        pvtInstallation,
        allinInstallation,
        postalcoderoseInstallation,
        retrofitInstallation,
        hybridInstallation,
        withoutprojects,
        meter
    },

    getters: {},

    actionsAsync: {}
} as AsyncModule<any, any>;
